export const getHelpDrawer = ({ identifier, slug }) => {
  const drawerOptions = {
    'sba': {
      'debt-schedule-upload': {
        btnText: 'What business debts do I need to report?',
        header: 'Funders need to know about all your debts to evaluate your ability to repay a new loan.',
        listHeader: 'What to include as a business debt:',
        list: [
          'Business credit card',
          'Line of credit',
          'Term loan',
          'Equipment financing',
          'Invoice financing',
          'Shareholder note',
        ],
        links: [ { href: '/bp/images/Example_Business_Debt_Schedule_2.png', text: 'See example' }],
        listFooter: 'Do not leave off any current known debt. Banks will conduct a search to validate your list and omitting debt will impact your eligibility.'
      },
      'debt-schedule': {
        btnText: 'What business debts do I need to include?',
        header: 'Funders need to know about all your debts to evaluate your ability to repay a new loan.',
        listHeader: 'What to include as a business debt:',
        list: [
          'Business credit card',
          'Line of credit',
          'Term loan',
          'Equipment financing',
          'Invoice financing',
          'Shareholder note',
        ],
        listFooter: 'Do not leave off any current known debt. Banks will conduct a search to validate your list and omitting debt will impact your eligibility.'
      },
      'profit-and-loss': {
        btnText: 'What should I show on a Profit & Loss Statement?',
        listHeader: 'A Profit & Loss Statement shows funders the following:',
        list: [
          'Your current revenue',
          'An itemized breakdown of all your expenses',
          'The resulting net profit. (Revenue - Expenses = Net Profit)',
          'The YTD document must be dated within the last 30 days. e.g. the Profit and Loss Statement must be dated from Jan-May 14th to be used as of June 14th',
        ],


        links: [
          { href: '/bp/images/pLExample.png', text: 'See example' },
          { href: 'https://cdn.lendio.com/production_borrower_portal/sba_templates/SBA%20Profit%20and%20Loss%20Template.xlsx', text: 'Use our template' },
        ]
      },
      'balance-sheet': {
        btnText: 'What should  I show on a Balance Sheet?',
        header: 'This document shows an itemized breakdown of your current assets and liabilities and helps the lender get a snapshot of your net worth through the current date of the year.',
        list: [
          'Your YTD P&L Dates must match the balance sheet dates',
          'All debts included in balance sheet must be on the debt schedule',
          'The total assets must equal total liabilities + equity (assets = liabilities + equity)',
        ],
        links: [
          { href: '/bp/images/Example_YTD_Balance_Sheet.png', text: 'See example' },
          { href: 'https://cdn.lendio.com/production_borrower_portal/sba_templates/SBA%20Balance%20Sheet%20Template.xlsx', text: 'Use our template' },
        ]
      }
    },
  }

  switch (identifier) {
    case 'emsba':
    case 'ltemsba':
      return drawerOptions['sba']?.[slug]
    default:
      return drawerOptions[identifier]?.[slug]
  }
}
